import { IsEnum, IsNumber, IsString } from "class-validator";

export enum StaffInvitationResolveActionEnum {
  MERGE = 'merge',
}

export enum StaffInvitationResolveTypeEnum {
  CONFLICT = 'conflict',
}

export class StaffInvitationResolveActions {
  @IsNumber()
  employeeId: number;

  @IsString()
  employeeNumber: string;

  @IsNumber()
  mealCardTypeId: number;

  @IsString()
  email: string;

  @IsEnum(StaffInvitationResolveActionEnum)
  resolveAction: StaffInvitationResolveActionEnum;

  @IsEnum(StaffInvitationResolveTypeEnum)
  type: StaffInvitationResolveTypeEnum;
}
